import React, { useEffect, useState } from 'react'
import Home from './home';

 
const HomeContainer = () => {
    const [copyRightDetails, setCopyRightDetails] = useState<any>([]);
    const [landingPageDetails, setLandingPageDetails] = useState<any>([]);
    const [myKomatsuRegion, setMyKomatsuRegion] = useState<any>([]);
    const [cdnURL,setCdnURL] = useState();

    useEffect(() => {
        fetchData();
        getLandingDetails();
    }, []);

    const fetchData = async () => {
        await fetch("/home/GetBlobCDNURL")
            .then(async (response) => await response.json())
            .then((json) => {
                setCdnURL(json.containerCDNURL);
            })
    };

    const getLandingDetails = async () => {
        await fetch("/home/GetLandingPageDetails")
            .then(async (response) => await response.json())
            .then((json) => {
                setCopyRightDetails(json.copyRightDetails);
                setLandingPageDetails(json.landingPageDetails);
                setMyKomatsuRegion(json.myKomatsuRegion)
            })
            .catch((error) => {
                setCopyRightDetails([]);
            });
    };

    return (  
        <Home
            cdnURL={cdnURL}
            copyRightDetails={copyRightDetails}
            landingPageDetails={landingPageDetails}
            myKomatsuRegion={myKomatsuRegion}
        />
    );
}
 
export default HomeContainer;